import { BaseGateway } from '../BaseGateway';
import { GatewayName } from '../types';

export class IntegrationGateway extends BaseGateway {
  name: GatewayName = 'integration';

  constructor() {
    super(undefined);
  }

  async installApp(query: {
    accountId: string;
    appCode: string;
    flowName: string;
    parameters: Record<string, string>;
  }): Promise<void> {
    await this.httpPost(
      'trigger/SW50ZWdyYXRpb246M2NhMWE5ODYtNjUxZS00MzkxLWFiYjItYWUxM2RmMzU2Nzg1',
      {
        data: query,
        // TODO: temp solution - if this solution stays, will likely need to use a per environment URL
        baseURL: 'https://hooks.integration.lynksupplychain.com',
      },
    );
  }
}
